__turbopack_context__.v({
  "date": "dateCell-module-scss-module__ppwtgq__date",
});
